﻿import { useState } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import Select from "react-select";
import CustomInputSwitch from "@/components/desktop/form/input/input-switch/CustomInputSwitch";
import { useLocation } from "react-router-dom";

import classes from "./ordersDeliveryFilter.module.scss";

import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";

const baseUnits = [
	{ value: 1, label: "g - cc" },
	{ value: 1000, label: "Kg - L" },
	{ value: 10000, label: "Tn - KL" },
];

const baseMovements = [
	{ value: "transfer", label: "Traspaso" },
	{ value: "implementation", label: "Carga Inicial" },
	{ value: "unassigned", label: "Sin Asignar" },
];

const OrdersDeliveryFilter = ({ filters, applyFilter }) => {
	let location = useLocation();

	const [typeMovement, setTypeMovement] = useState(filters && filters.typeMovement);
	const [defaultUnitFilter, setDefaultUnitFilter] = useState(filters && filters.defaultUnitFilter);
	const [purchaseOrderDeliveryFilter, setPurchaseOrderFilter] = useState(filters && filters.purchaseOrderDeliveryFilter);
	const [dateFilter, setDateFilter] = useState(filters && filters.dateFilter);
	const [dateToFilter, setDateToFilter] = useState(filters && filters.dateToFilter);
	const [showEmptyFilter, setShowEmptyFilter] = useState(filters && filters.showEmptyFilter ? filters.showEmptyFilter : false);

	const handleCleanFilter = () => {
		applyFilter({
			purchaseOrderDeliveryFilter: "",
			defaultUnitFilter: 1000,
			dateFilter: "",
			dateToFilter: "",
			showEmptyFilter: false,
			typeMovement: "",
		});
	};

	const handleApplyFilter = () => {
		applyFilter({
			purchaseOrderDeliveryFilter,
			defaultUnitFilter,
			dateFilter,
			dateToFilter,
			showEmptyFilter,
			typeMovement,
		});
	};

	return (
		<Col md={2} className={classes.filter}>
			<div className={classes.filterTitle}>
				<h4 className={classes.titleH4}>Filtros</h4>
				<hr className={classes.filterHr} />
			</div>

			<div className={classes.divContent}>
				{location.pathname.includes("sin_documento") ? (
					<Row className={classes.divForm}>
						<Col md={12} className={classes.divLabel}>
							<span className={classes.label}>Tipo de Movimiento</span>
						</Col>
						<Col md={12}>
							<Select
								value={baseMovements && baseMovements.filter((b) => String(b.value) === String(typeMovement))}
								placeholder={<div>Seleccione</div>}
								options={baseMovements ? baseMovements : []}
								onChange={(value) => setTypeMovement(value.value)}
								components={{ NoOptionsMessage }}
							/>
						</Col>
					</Row>
				) : (
					<>
						<Row className={classes.divForm}>
							<Col md={12} className={classes.divLabel}>
								<span className={classes.label}>N° Guía de Despacho</span>
							</Col>
							<Col md={12}>
								<Form.Control
									type="text"
									name="order_code"
									placeholder=" "
									value={purchaseOrderDeliveryFilter ? purchaseOrderDeliveryFilter : ""}
									onChange={(e) => setPurchaseOrderFilter(e.target.value)}
								/>
							</Col>
						</Row>

						<Row className={classes.divForm}>
							<Col md={12} className={classes.divLabel}>
								<span className={classes.label}>Ver solo sin Documento</span>
							</Col>
							<Col md={12}>
								<CustomInputSwitch
									value={showEmptyFilter}
									optionLeft="NO"
									optionRight="SI"
									onChange={(checked) => {
										setShowEmptyFilter(checked);
									}}
								/>
							</Col>
						</Row>
					</>
				)}

				<hr />

				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>Unidad de Medida</span>
					</Col>
					<Col md={12}>
						<Select
							value={baseUnits && baseUnits.filter((b) => Number(b.value) === Number(defaultUnitFilter))}
							placeholder={<div>Seleccione</div>}
							options={baseUnits ? baseUnits : []}
							onChange={(value) => setDefaultUnitFilter(value.value)}
							components={{ NoOptionsMessage }}
						/>
					</Col>
				</Row>

				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>Fecha Ingreso</span>
					</Col>
					<Col md={12}>
						<small>Desde</small>
						<Form.Control
							type="text"
							name="created_at"
							placeholder=" "
							value={dateFilter}
							onChange={(e) => setDateFilter(e.target.value)}
							onFocus={(e) => (e.target.type = "date")}
						/>
					</Col>
					<Col md={12}>
						<small>Hasta</small>
						<Form.Control
							type="text"
							name="created_at"
							placeholder=" "
							value={dateToFilter}
							onChange={(e) => setDateToFilter(e.target.value)}
							onFocus={(e) => (e.target.type = "date")}
						/>
					</Col>
				</Row>
			</div>

			<div className={classes.divFooter}>
				<Button className={classes.buttonClean} onClick={() => handleCleanFilter()}>
					Limpiar
				</Button>

				<Button className={classes.buttonApply} onClick={() => handleApplyFilter()}>
					Aplicar
				</Button>
			</div>
		</Col>
	);
};

export default OrdersDeliveryFilter;
